<template>
  <div v-if="show" class="report-notification">
    <div class="notification-content">
      <div class="notification-icon">📊</div>
      <div class="notification-text">
        <div class="notification-title">{{ notificationTitle }}</div>
        <div class="notification-message">{{ notificationMessage }}</div>
      </div>
      <div class="notification-actions">
        <button v-if="isOnReportsPage" class="btn-ok" @click="handleOk">OK</button>
        <button v-else class="btn-go" @click="handleGo">Go</button>
        <button class="btn-close" @click="closeNotification">×</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventPopup',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isOnReportsPage: {
      type: Boolean,
      default: false,
    },
    notificationData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    notificationTitle() {
      return (this.notificationData && this.notificationData.title) || 'Report Ready';
    },
    notificationMessage() {
      return (this.notificationData && this.notificationData.body) || 'Your report has been generated successfully';
    },
  },
  methods: {
    handleOk() {
      this.$emit('ok');
    },
    handleGo() {
      this.$emit('go');
    },
    closeNotification() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.report-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10000;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-left: 4px solid #4CAF50;
  animation: slideIn 0.3s ease-out;
  min-width: 350px;
  font-family: inherit;
}

.notification-content {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 12px;
}

.notification-icon {
  font-size: 24px;
}

.notification-text {
  flex: 1;
}

.notification-title {
  font-weight: 600;
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
  font-family: inherit;
}

.notification-message {
  font-size: 13px;
  color: #666;
  font-family: inherit;
}

.notification-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.btn-ok, .btn-go {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  font-weight: 500;
  font-family: inherit;
}

.btn-ok:hover, .btn-go:hover {
  background: #45a049;
}

.btn-close {
  background: none;
  border: none;
  color: #999;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
}

.btn-close:hover {
  color: #666;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>